import { InviteCategory } from '@/domain/external-invitation/entities/invitation-category';
import { Sector } from '@/domain/impact/impact.entity';
import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';

export interface ExternalInvitation {
  id: number;
  projectId: number;
  email: string;
  name: string;
  sector: Sector;
  code: string;
  active: boolean;
  scope: Scope;
  scopeUrl: string;
  expirationDate: string;
  eventPosition: PositionGeocode | undefined;
  title: string;
  completion: number;
  co2ImpactScore: string;
  status: Status;
  isValidated: boolean;
  category: InviteCategory;
  createdAt: string;
}

export type Scope = (typeof ScopeValues)[number];
export const ScopeValues = [
  '',
  // FESTIVAL
  'TEAM',
  'ARTISTS',
  'PUBLIC',
  'PUBLIC_SUPPLIER',
  'SITE',
  // FESTIVAL CATEGORIES
  'TEAM-MOBILITY',
  'TEAM-CATERING',
  'TEAM-ACCOMMODATION',
  'ARTISTS-MOBILITY',
  'ARTISTS-CATERING',
  'ARTISTS-ACCOMMODATION',
  'ARTISTS-CARGO',
  'SITE-ENERGY-WATER-WASTE',
  'SITE-EQUIPMENT-CARGO',
  'SITE-BUILDING',
  // VENUE-STRUCTURE
  'VENUE-STRUCTURE-SITE',
  'VENUE-STRUCTURE-TEAM',
  // VENUE-STRUCTURE CATEGORIES
  'VENUE-STRUCTURE-TEAM-TRANSPORT',
  'VENUE-STRUCTURE-TEAM-CATERING',
  'VENUE-STRUCTURE-SITE-SCENOGRAPHY',
  'VENUE-STRUCTURE-SITE-MATERIAL',
  'VENUE-STRUCTURE-SITE-BUILDING',
  'VENUE-STRUCTURE-SITE-ENERGY',
  'VENUE-STRUCTURE-SITE-WATER',
  'VENUE-STRUCTURE-SITE-WASTE',
  'VENUE-STRUCTURE-SITE-EQUIPMENT',
  'VENUE-STRUCTURE-PUBLIC',
  'VENUE-STRUCTURE-PUBLIC-CATERING',
  'VENUE-STRUCTURE-PUBLIC-DIGITAL',
  // VENUE-DATES
  'VENUE-DATES-ARTISTS',
  // VENUE-DATES CATEGORIES
  'VENUE-DATES-ARTISTS-MOBILITY',
  'VENUE-DATES-ARTISTS-CATERING',
  'VENUE-DATES-ARTISTS-ACCOMMODATION',
  'VENUE-DATES-ARTISTS-CARGO',
  // SURVEY
  'SURVEY-MOBILITY-ACCOMMODATION',
] as const;

export type Status = (typeof StatusValues)[number];
export const StatusValues = [
  '',
  'IN_PROGRESS',
  'SUBMITTED',
  'ARCHIVED',
] as const;
